import { useGLTF } from "@react-three/drei"
import gltfModel from "../../assets/scenes/scenes.glb"
import { RigidBody } from "@react-three/rapier"
import { LightSimple } from "../../components/elements/light-simple"
import { useEffect } from "react"
import { LightPlane } from "../../components/elements/light-plane"
import { StartPcScreen } from "./components/start-pc-screen"
import { StartTable } from "./components/start-table"
import { StartWaitZone } from "./components/start-wait-zone"
import { StartRobot } from "./components/start-robot"
import { StartProjects } from "./components/start-projects"
import { StartPre } from "./components/start-pre"
import { StartEffects } from "./components/start-effects"
import { StartTree } from "./components/start-tree"


const LevelStart = () => {
  const model= useGLTF(gltfModel)

  useEffect(() => {
    model.materials["light-mat"].emissiveIntensity = 1000
  }, [])

  return (
    <>
      <StartEffects />
      <StartPcScreen model={model} />
      <StartTable model={model} />
      <StartWaitZone model={model} />
      <StartRobot model={model} />
      <StartProjects model={model} />
      <StartPre model={model} />
      <StartTree model={model} />


      <LightSimple position={[3.3, 3, 0]} />
      <LightSimple position={[-10, 3, 0]} />
      <LightSimple position={[11, 3, 0]} />
      <LightPlane intensity={3} rotation={[-(Math.PI / 2), 0, 0]} position={[-14.6, 4.7, 7.5]} size={[0.5, 2]} />
      <LightPlane intensity={5} rotation={[-(Math.PI / 2), 0, 0]} position={[-1, 5, 6]} size={[24, 1.2]} />
      <LightPlane intensity={5} rotation={[-(Math.PI / 2), 0, 0]} position={[-1, 5, -6]} size={[24, 1.2]} />
      <ambientLight intensity={0} color="#fff" />

      <primitive object={model.nodes["clock"]} />


      <primitive object={model.nodes["zag"]} />
      <primitive object={model.nodes["columns"]} />
      <primitive object={model.nodes["start-wall-3"]} />
      <primitive object={model.nodes["start-wall-4"]} />
      <primitive object={model.nodes["start-lamp"]} />
      <primitive object={model.nodes["start_logo_wall"]} />
      <primitive object={model.nodes["art-1"]} />
      <primitive object={model.nodes["art-2"]} />
      <primitive object={model.nodes["start_tv1"]} />
      <primitive object={model.nodes["start_tv2"]} />
      <primitive object={model.nodes["start_tv3"]} />
      <primitive object={model.nodes["start_pl1"]} />
      <primitive object={model.nodes["start-elevator"]} />
      <primitive object={model.nodes["start-elevator-btn"]} />
      <primitive object={model.nodes["start_icons_ramp"]} />
      <primitive object={model.nodes["start_icon1"]} />
      <primitive object={model.nodes["start_icon2"]} />
      <primitive object={model.nodes["start_icon3"]} />
      <primitive object={model.nodes["start_icon4"]} />
      <primitive object={model.nodes["start_icon5"]} />
      <primitive object={model.nodes["start_icon6"]} />
      <primitive object={model.nodes["start_icon7"]} />
      <primitive object={model.nodes["reception_text"]} />
      <primitive object={model.nodes["exit"]} />
      <primitive object={model.nodes["kettle"]} />
      <primitive object={model.nodes["coffee"]} />
      <primitive object={model.nodes["coffee2"]} />

      <RigidBody type="fixed" colliders="trimesh">
        <primitive object={model.nodes["start-floor"]} />
      </RigidBody>

      <RigidBody type="fixed" colliders="trimesh">
        <primitive object={model.nodes["table_idea"]} />
      </RigidBody>

      <RigidBody type="fixed" colliders="trimesh">
        <primitive object={model.nodes["start_big_table"]} />
      </RigidBody>

      <RigidBody type="fixed" colliders="cuboid">
        <primitive object={model.nodes["start_flor1"]} />
      </RigidBody>
      <RigidBody type="fixed" colliders="cuboid">
        <primitive object={model.nodes["start_flor2"]} />
      </RigidBody>
      <RigidBody type="fixed" colliders="cuboid">
        <primitive object={model.nodes["start_flor3"]} />
      </RigidBody>
      <RigidBody type="fixed" colliders="cuboid">
        <primitive object={model.nodes["start_flor4"]} />
      </RigidBody>

      <RigidBody type="fixed" colliders="cuboid">
        <primitive object={model.nodes["start-dec-1"]} />
      </RigidBody>
      <RigidBody type="fixed" colliders="cuboid">
        <primitive object={model.nodes["start_pc"]} />
      </RigidBody>
      <RigidBody type="fixed" colliders="cuboid">
        <primitive object={model.nodes["start-dec-2"]} />
      </RigidBody>
      <RigidBody type="fixed" colliders="cuboid">
        <primitive object={model.nodes["start-wall--top"]} />
      </RigidBody>
      <RigidBody type="fixed" colliders="cuboid">
        <primitive object={model.nodes["start-wall-1"]} />
      </RigidBody>

      <RigidBody type="fixed" colliders="cuboid">
        <primitive object={model.nodes["start-wall-1"]} />
      </RigidBody>

      <RigidBody type="fixed" colliders="cuboid">
        <primitive object={model.nodes["start-wall-2"]} />
      </RigidBody>

      <RigidBody type="fixed" colliders="trimesh">
        <primitive object={model.nodes["start-table"]} />
      </RigidBody>
      <RigidBody type="fixed" colliders="trimesh">
        <primitive object={model.nodes["start_recept_wall"]} />
      </RigidBody>
    </>
  )
}


export {
  LevelStart
}